// IR-661 Phase 7 Task 12 — Country alpha-2 list for the EntityEditSheet's
// PhoneAppdata sub-form.
//
// Source of truth: api/ops/serializers_data.py:24-32 (`_FALLBACK_ALPHA2`).
// The backend's PhoneAppdataUpdateSerializer.validate_country() rejects
// codes outside this set (or whatever active rows live in the `countries`
// table — at minimum the fallback). Mirroring the fallback list here gives
// the UI a stable dropdown without an extra round-trip.
//
// We deliberately do NOT ship a full ISO 3166 list; doing so would let the
// FE accept codes the backend will then 400-reject (Q3a hybrid validation:
// country = ChoiceField on the backend). Keep the FE list aligned with
// the backend's accepted set.

export const COUNTRY_ALPHA2_CODES: readonly string[] = [
  "AE",
  "AF",
  "AL",
  "AR",
  "AT",
  "AU",
  "BE",
  "BG",
  "BR",
  "CA",
  "CH",
  "CL",
  "CN",
  "CO",
  "CY",
  "CZ",
  "DE",
  "DK",
  "DZ",
  "EE",
  "EG",
  "ES",
  "ET",
  "FI",
  "FR",
  "GB",
  "GR",
  "HK",
  "HR",
  "HU",
  "ID",
  "IE",
  "IL",
  "IN",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JO",
  "JP",
  "KE",
  "KR",
  "KW",
  "LB",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MX",
  "MY",
  "NG",
  "NL",
  "NO",
  "NZ",
  "OM",
  "PE",
  "PH",
  "PK",
  "PL",
  "PS",
  "PT",
  "QA",
  "RO",
  "RS",
  "RU",
  "SA",
  "SE",
  "SG",
  "SI",
  "SK",
  "SY",
  "TH",
  "TN",
  "TR",
  "TW",
  "UA",
  "US",
  "UY",
  "UZ",
  "VE",
  "VN",
  "YE",
  "ZA",
];
